import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  options: {
    marginTop: 8,
    width: '100%'
  },
  deleteButton: {
    minWidth: '32px'
  },
  validationTitle: {
    marginBottom: 8
  }
}))
